<template>
  <div class="page page-bankcard">
    <navigation>{{ pageTitle }}</navigation>
    <section class="content">
      <form class="form" ref="form">
        <div class="form-box">
          <div class="form-item underline-un-focus">
            <div class="label">银行卡</div>
            <nd-input
              v-model="form.bankcardNo"
              name="bankcardNo"
              type="pure-number"
              placeholder="请提供境内储蓄银行卡号"
              :disabled="!isModify"
            >
            </nd-input>
          </div>
        </div>
        <!-- 如果已实名，则只展示持卡人，且为只读、否则可编辑持卡人和身份证号 -->
        <template v-if="isFirst">
          <div class="form-box">
            <div class="form-item underline-un-focus">
              <div class="label">持卡人</div>
              <nd-input
                v-model="form.name"
                name="name"
                placeholder="请输入姓名"
              />
            </div>
            <div class="form-item underline-un-focus">
              <div class="label">身份证</div>
              <nd-input
                v-model="form.idCard"
                name="idCard"
                placeholder="请输入身份证号"
              />
            </div>
          </div>
          <div class="form-tips">提醒：后续绑卡只能绑定该持卡人的银行卡</div>
        </template>
        <div v-else class="form-box">
          <div class="form-item underline-un-focus">
            <div class="label">持卡人</div>
            <nd-input
              :value="userInfo.name"
              name="name"
              readonly
              placeholder=""
            />
          </div>
        </div>
        <div class="form-box">
          <div
            class="form-item underline-un-focus"
            :class="{ modify: isUpdateMode }"
          >
            <div class="label">手机号码</div>
            <nd-input
              v-model="form.bankMobile"
              name="bankMobile"
              :readonly="!isUpdateModePhone"
              type="pure-number"
              maxLength="11"
              placeholder="请输入银行卡预留手机号"
              ref="mobile"
            >
            </nd-input>
            <span
              v-if="isUpdateMode"
              class="modify-append"
              @click="modifyMobile"
            >修改</span>
          </div>
        </div>
      </form>
      <div class="support" @click="supportBank" data-sensors-click>
        <img
          src="./images/icon_chakan.png"
          srcset="
              ./images/icon_chakan@2x.png 2x,
              ./images/icon_chakan@3x.png 3x
          "
        />查看支持的银行卡列表
      </div>
    </section>

    <nd-sms
      ref="sms"
      :duration="duration"
      :showMobile="false"
      :tips="smsTips"
      v-model="smsVisible"
      @retrieve="sendSmsAgain"
      @confirm="confirmBind"
      :errorTip="errorTip"
      @countEnd="countEnd"
      @close="closeSms"
    ></nd-sms>
    <div v-if="showProtocol" class="protocol">
      <van-checkbox
        v-model="proChecked"
        class="pro-check"
        icon-size="0.37rem"
        checked-color="#FF4633"
      ></van-checkbox>
      同意<span @click="$router.push('/protocol/bankcard-pay')">《快捷支付服务协议》及相关协议</span>
    </div>
    <nd-button class="btn" :disabled="isDisabled || (showProtocol && !proChecked)" v-stat="{id: 20292}" @click="next">确认</nd-button>

    <!-- 强弹征信协议 -->
    <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="greyShow?false:true">
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="authenticationProtocol" frameborder="0"></iframe>
      </div>
      <div class="btn-wrapper">
        <nd-button v-if="!greyShow" class="btn" @click="authenticationVisible = false">我已完成阅读并同意上述协议</nd-button>
        <nd-button v-if="greyShow" :disabled="COUNT_DOWN > 0" class="btn" @click="authenticationVisible = false">我已阅读并同意上述协议{{countdownSubfix}}</nd-button>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import validate from '../../components/nd-validate'
import NdSms from './components/nd-sms'
import { mapActions, mapState } from 'vuex'
import { Checkbox } from 'vant'
import { isTMDMiniprogram, getKey } from '@/assets/utils'
import wx from 'weixin-webview-jssdk'
import { jsBridge } from '../../assets/jsBridge.js'


export default {
  name: 'bankcard-add',

  mixins: [validate],

  customReadyNotify: true,

  components: {
    NdSms,
    [Checkbox.name]: Checkbox
  },

  data () {
    const proOrgin = process.env.VUE_APP_PROURL
    return {
      position: this.$route.query.position || 'loan', // 埋点需要，判断来源，如果没有值默认为借款
      isFirst: false, // 是否未实名首次绑卡，根据userInf.name来判断
      // showProtocol: this.$route.query.showPro === 'T', // 是否需要展示协议，根据url上的参数showPro === 'T'来判断
      showProtocol: true,
      form: {
        name: '',
        idCard: '',
        bankMobile: '',
        bankcardNo: ''
      },
      proChecked: false,
      rules: {
        bankcardNo: [
          {
            require: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          },
          {
            regular: /^\d{8,28}$/,
            message: '请输入正确的银行卡号',
            trigger: 'blur'
          }
        ],
        bankMobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      isDisabled: true,
      isUpdateMode: false, // 是否为换绑银行卡
      isUpdateModePhone: true,
      isModify: true, // 是否可以修改银行卡
      pageTitle: '绑定银行卡',
      smsVisible: false,
      loanPlatform: this.$route.query.loanPlatform || 'TMD',
      fundCode: this.$route.query.fundCode,
      smsKey: '',
      errorTip: '',
      duration: 120,
      canSendSms: true,
      bankMobile: '',
      lastModified: {
        bankMobile: '',
        bankcardNo: ''
      },
      isWxMiniprogramListToAdd: this.$route.query.isWxMiniprogramListToAdd, // 是否是微信小程序中卡列表到添加的流程
      isWxMiniProgramRepay: this.$route.query.isWxMiniProgramRepay, // 小程序中H5还款流程直接进行绑卡
      authenticationVisible: false,
      authenticationProtocol: `${proOrgin}/protocol/zhixing/service?hideNav=Y`,
      testUrl: location.origin,
      greyShow: true,
      COUNT_DOWN: 10,
      timer: null
    }
  },

  async created () {
    try {
      this.$report({
        id: 20994,
        args: {
          position: this.position
        }
      })
      await this.getUserInfoX({ forceUpdate: true })
      // 重新绑卡逻辑
      const bankcardNo = this.$route.query.bankcardNo
      let canChangePhoneNo = this.$route.query.canChangePhoneNo
      this.form.bankMobile = this.$route.query.bankMobile || this.userInfo.mobile
      const canEdit = this.$route.query.canEdit === 'Y'
      if (bankcardNo) {
        this.form.bankcardNo = bankcardNo
        if (canChangePhoneNo === 'true' || canChangePhoneNo === true) {
          this.isUpdateMode = true
        } else {
          this.isUpdateMode = false
        }
        this.isUpdateModePhone = canEdit || false
        this.isModify = canEdit || false
      } else {
        if (canChangePhoneNo === 'false') {
          this.isUpdateModePhone = false
        } else {
          this.isUpdateModePhone = true
        }
      }
      // 如果不是第一次绑卡，则获取上次绑卡的信息
      if (!this.userInfo.name) {
        this.isFirst = true
        this.rules = Object.assign({}, this.rules, {
          name: [
            { require: true, message: '请输入持卡人姓名', trigger: 'blur' },
            { regular: /^[\u4e00-\u9fa5]{2,10}$/, message: '持卡人姓名格式不正确', trigger: 'blur' }
          ],
          idCard: [
            { require: true, message: '请输入身份证号码', trigger: 'blur' }
          ]
        })
        this.$nextTick(() => {
          this.validator(this.$refs['form'], this.rules)
        })
      }
      this.$bus.$emit('ready')
      // 延迟调用js方法 
      setTimeout(() => {
        if (getKey('appChannel')?.startsWith('Android_')) {
          jsBridge('showZhiXingProtocolDialog')
        } else if (getKey('appChannel') === 'official-iOS') {
          // do nothing
        } else {
          this.showForceProtocol()
        }
      }, 500)
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),

    smsTips () {
      return `
      <span>您正在绑定银行卡，绑卡验证短信已发送您的手机<em>${this.formatMobile(this.bankMobile)}</em>，请注意查收</span>
      <div style="margin-top: 20px">服务过程中，可能存在多次绑卡短信验证，请知悉 </div>
      `
    },
    countdownSubfix () {
      if (this.COUNT_DOWN > 0) {
        return ` (${this.COUNT_DOWN}S)`
      }
      return ''
    }

  },
  beforeRouteEnter (from, to, next) {
    next((vm) => {
      vm.$bus.$emit('ready')
    })
  },
  methods: {
    ...mapActions('user', ['getUserInfoX']),
    ...mapActions('bankcard', [
      'bindBankcardApplyV2X',
      'bindBankcardConfirmV2X',
      'overdueBindApplyX',
      'overdueBindConfirmX'
    ]),

    modifyMobile () {
      this.isUpdateModePhone = true
      this.isUpdateMode = false
      this.$refs['mobile'].focus()
    },

    // 倒计时结束可再次发送验证码
    countEnd () {
      this.canSendSms = true
    },

    async next () {
      // 如果表单信息发生了改变，则需要重新发送验证码
      if (this.form.bankMobile !== this.lastModified.bankMobile || this.form.bankcardNo !== this.lastModified.bankcardNo) {
        this.canSendSms = true
      }

      this.errorTip = ''
      this.bankMobile = this.form.bankMobile
      // 如果上一次验证码倒计时还没结束，则直接弹出验证码弹窗
      if (!this.canSendSms) {
        this.smsVisible = true
        return
      }
      try {
        await this.bindBankcardApply()
        this.canSendSms = false
        this.$refs.sms.reset()
        this.smsVisible = true
        this.lastModified.bankMobile = this.form.bankMobile
        this.lastModified.bankcardNo = this.form.bankcardNo
      } catch (exp) {
        this.$message(exp.message)
      }
    },

    // 申请绑卡
    async bindBankcardApply () {
      this.bankMobile = this.form.bankMobile
      if (window.pending) return
      window.pending = true
      const params = {
        loanPlatform: this.loanPlatform || 'TMD',
        bankCardNo: this.form.bankcardNo,
        fundCode: this.fundCode,
        bankMobile: this.form.bankMobile,
        orderId: this.$route.query.orderId
      }
      if (this.isFirst) {
        params.name = this.form.name
        params.idCard = this.form.idCard
      }
      let response = { success: false }
      if (this.$route.query.type === 'OVERDUE_BIND') {      
        response = await this.overdueBindApplyX(params)
      } else {
        response = await this.bindBankcardApplyV2X(params)
      }
      window.pending = false
      if (response.success) {
        this.smsKey = response.data.smsKey
        return true
      } else {
        if (response.code === '000028') {
          this.smsVisible = true
          this.canSendSms = false
          this.smsKey = response.msg
        } else if (response.code === 'TMD073') {
          // 增加异常码(TMD073)该卡已绑定长银消金
          this.$message(response.msg)
          setTimeout(() => {
            this.handleBandBack()
          }, 2000)
        } else {
          throw new Error(response.msg)
        }
      }
    },
    handleBandBack () {
      if (isTMDMiniprogram()) {
        // 微信小程序流程
        // 如果是卡列表来添加，添加完成则返回卡列表
        // 如果是小程序中还款流程（H5流程），直接跳转，则返回上一个H5页面
        // 如果是小程序其他地方直接跳转添加页面，添加完成则直接关闭webview
        if (this.isWxMiniprogramListToAdd === 'Y' || this.isWxMiniProgramRepay === 'Y') {
          this.$router.go(-1)
        } else {
          wx.miniProgram.postMessage({ data: { eventType: 'ONELY_NAVIGATE_BACK', eventId: '', url: '', value: null } })
          wx.miniProgram.navigateBack()
        }
      } else {
        this.$router.go(-1)
      }
    },

    // 点击重新发送验证，reset可以重置弹出框倒计时状态
    async sendSmsAgain (reset) {
      this.errorTip = ''
      try {
        await this.bindBankcardApply()
        this.canSendSms = false
        reset()
      } catch (exp) {
        this.$message(exp.message)
      }
    },

    // 点击确认绑卡后把输入的验证码回传回来
    async confirmBind (code) {
      const params = {
        smsKey: this.smsKey,
        loanPlatform: this.loanPlatform,
        smsCode: code,
        productCd: this.productCd,
        fundCode: this.fundCode
      }
      let response = { success: false }
      if (this.$route.query.type === 'OVERDUE_BIND') {
        params.cardNumber = this.form.bankcardNo
        response = await this.overdueBindConfirmX(params)
      } else {
        response = await this.bindBankcardConfirmV2X(params)
      }
      if (response.success) {
        this.smsVisible = false
        if (response.data.follow === 'Y') {
          if (response.data?.nextFundPartnerCd) {
            this.fundCode = response.data?.nextFundPartnerCd
          }
          this.canSendSms = true
          setTimeout(() => {
            this.next()
          }, 1000)
        } else {
          this.$message('绑卡成功')
          setTimeout(() => {
            this.handleBandBack()
          }, 500)
        }
      } else {
        if (response.code === '000010') {
          this.errorTip = response.msg
        }
      }
    },

    // 查看支持银行卡
    supportBank () {
      this.navigateTo(`/bankcard/support?loanPlatform=${this.loanPlatform}&fundCode=${this.fundCode || 'ndmicro'}`)
    },

    // 导航
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },

    // 用户主动关闭弹窗
    closeSms () {
      this.$report({
        id: 10046,
        args: {
          position: this.loanPlatform
        }
      })
    },
    showForceProtocol () {
      this.authenticationVisible = true
      this.greyShow = true
      if (this.greyShow) {
        this.COUNT_DOWN = 10
        this.countdown()
      }
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },
    countdown () {
      this.timer = setInterval(() => {
        if (this.COUNT_DOWN < 1) {
          clearInterval(this.timer)
        } else {
          this.COUNT_DOWN--
        }
      }, 1000)
    },
    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-bankcard{
  background-color: #eeeeee;
}
.page {
    display: flex;
    flex-direction: column;
    .content {
        flex: 1;
        .form {
            margin-top: 20px;
            .form-box{
              background-color: #fff;
              padding: 0 50px 40px;
              margin-top: 20px;
              overflow: hidden;
            }
            .form-tips{
              font-size: 24px;
              color: #999999;
              padding: 12px 50px 0;
            }

            .form-item {
                margin-top: 48px;
                padding-bottom: 14px;

                &.modify {
                    .nd-input {
                        margin-right: 80px;
                        width: unset;
                    }

                    .modify-append {
                        font-size: 28px;
                        width: 70px;
                        bottom: 11px;
                        right: 0px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        position: absolute;
                        color: #8eb2d8;
                    }
                }

                &.support-bank {
                    font-size: 28px;
                    color: #4b94f0;
                }

                &.code {
                    .nd-input {
                        margin-right: 160px;
                        width: unset;
                    }
                }

                .nd-input {
                    height: 42px;
                    line-height: 42px;
                    margin-bottom: 8px;
                }

                .send-code {
                    width: 150px;
                    border-radius: 28px;
                    bottom: 8px;
                    right: 0px;
                    position: absolute;

                    span {
                        display: inline-block;
                        font-size: 22px;
                    }
                }
            }
        }
        .support {
            display: flex;
            align-items: center;
            font-size: 26px;
            color: rgba(142, 178, 216, 1);
            padding: 23px 50px 0;
            > img {
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
    }
    .protocol{
      font-size: 24px;
      color: #999999;
      display: flex;
      justify-content: center;
      align-items: center;
      .pro-check{
        margin-right: 20px;
      }
      span{
        color: #8EB2D8;
      }
    }

    .btn {
        display: block;
        width: 650px;
        margin: 35px auto 90px;
    }

    .auth-dialog {
    .default-content {
      width: 620px;
      border-radius: 30px 30px 0 0;
      padding-top: 40px;
      padding-left: 20px;
      padding-right: 20px;
      background: white;
      height: 638px;
      overflow: auto;

      .dialog-title {
        text-align: center;
        font-size: 36px;
        padding-bottom: 15px;
        font-weight: 600;
      }

      .dialog-footer {
        padding: 0 50px;
        padding-bottom: 40px;
        display: flex;
        justify-content: space-between;
        background-color: #FFFFFF;

        .btn {
          width: 240px;
          height: 80px;
          line-height: 80px;
        }
      }
    }

    .iframe {
      height: 638px;
      width: 100%;

      html {
        width: 100%;
      }
    }

    .btn-wrapper {
      position: fixed;
      background: white;
      height: 162px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 620px;
      border-radius: 0 0 30px 30px;
      transform: translateY(-20px);

      .btn {
        width: 500px;
      }
    }
  }
}
</style>
